import {v4 as uuidv4} from 'uuid'
import {jumpHome, jumpPassport} from "@/utils/url_redirection";

export function generateState(route) {
	let uuid = uuidv4();
	uuid = uuid.replaceAll('-', '')
	let saveRoute = {};
	if(typeof route === 'object') {
		saveRoute = route
	}else {
		saveRoute = {
			path: route,
			query: {}
		}
	}
	sessionStorage.setItem(uuid, JSON.stringify(saveRoute))
	return uuid;
}

export function parseState(state) {
	let route = sessionStorage.getItem(state) || '{}'
	sessionStorage.removeItem(state)
	return JSON.parse(route)
}

export function generateRedirect(passportRoute, route) {
	let state = generateState(route);
	return `${jumpPassport()}${passportRoute}?clientId=zhuzaobao&redirectUri=${jumpHome()}&state=${state}`
}
